import { Button } from '@fukuri-admins/ui/common';
import clsx from 'clsx';
import type { StressAssessmentRole } from '~/types/model/stressAssessment';
import styles from './styles.module.scss';

type Props = {
  selectedRole: StressAssessmentRole;
  onRoleChange: (role: StressAssessmentRole) => void;
  onSubmit: () => void;
};

type RoleOption = {
  value: StressAssessmentRole;
  title: string;
  description: string;
  image: string;
};

const roleOptions: RoleOption[] = [
  {
    value: 'practitioner',
    title: '実務担当者',
    description: '労務担当者、同意のない個人結果を閲覧できない方はこちら',
    image: '/stress-check-practitioner.svg',
  },
  {
    value: 'implementer',
    title: '実施者',
    description: '産業医、保健師、全従業員の個人結果を閲覧できる方はこちら',
    image: '/stress-check-implementer.svg',
  },
];

export const StressAssessmentRoleSelectPresentation: React.FC<Props> = ({
  selectedRole,
  onRoleChange,
  onSubmit,
}) => {
  return (
    <div className={styles.pageWrapper}>
      <header className={styles.pageHeader}>
        <h1 className={styles.pageTitle}>ストレスチェック</h1>
      </header>

      <main className={styles.pageBody}>
        <h2 className={styles.sectionTitle}>ストレスチェックの実施</h2>
        <p className={styles.sectionDescription}>
          ストレスチェックは、法律上閲覧できる管理者が制限されています。閲覧権限がある方のみ、自身の役割を選択して利用を開始してください。
        </p>

        <div className={styles.roleSelectWrapper}>
          <h3 className={styles.roleSelectHeading}>あなたの役割</h3>
          <div className={styles.roleSelectContainer}>
            {roleOptions.map(option => (
              <label
                key={option.value}
                className={clsx(styles.card, {
                  [styles.selected]: selectedRole === option.value,
                })}
              >
                <input
                  type='radio'
                  name='role'
                  value={option.value}
                  checked={selectedRole === option.value}
                  onChange={() => onRoleChange(option.value)}
                  className={styles.input}
                />
                <div className={styles.imageWrapper}>
                  {option.image && (
                    <img src={option.image} alt={option.title} className={styles.image} />
                  )}
                </div>
                <div className={styles.content}>
                  <h4 className={styles.title}>{option.title}</h4>
                  <p className={styles.description}>{option.description}</p>
                </div>
                <div className={styles.radioIndicator} />
              </label>
            ))}
          </div>
        </div>
        <Button onClick={onSubmit} size='md'>
          利用を始める
        </Button>
      </main>
    </div>
  );
};
